/**
 * The handful of facts the two legal documents share.
 *
 * Kept in one place because they are the values most likely to be wrong: the
 * effective date has to move whenever either document is revised, the contact
 * address is published to the public internet, and the governing-law state is
 * the Firm's decision rather than a detail of the software. Two copies of any
 * of them is two chances to update one and not the other.
 *
 * `LEGAL_EFFECTIVE_DATE` is a written date rather than a formatted `Date`: it
 * is the date the Firm adopted these terms, not today, and it must not change
 * because a page was rendered in a different month.
 */
export const LEGAL_EFFECTIVE_DATE = '1 September 2026'

/** Published on both documents; Intuit requires a reachable one on the policy. */
export const LEGAL_CONTACT_EMAIL = 'info@josephialaw.com'

export const LEGAL_GOVERNING_STATE = 'Maryland'
